module.exports = __webpack_public_path__ + "static/media/ding_for_first_pos.5e91d9c2.wav";